import { Tooltip } from 'antd';
import { tagCloseIconStyle } from 'src/app/pages/NetworkPage/MyDetails/my-details.config';
import { PureCancelIcon } from 'src/icons';

const OrderedTags = ({
  tags,
  setTags,
}: {
  tags: string[];
  setTags: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  return (
    <div className="enter-input-tags">
      {tags?.map((tag, idx) => {
        if (idx >= 5) return null;
        if (idx + 1 <= 4) {
          return (
            <div key={idx}>
              <div className="enter-input-tag" id="tag-button">
                <Tooltip title={tag}>
                  <span className="enter-input-tagText">{tag}</span>
                </Tooltip>
                <PureCancelIcon
                  style={tagCloseIconStyle}
                  onClick={() => {
                    setTags(tags.filter((address) => address !== tag));
                  }}
                />
              </div>
            </div>
          );
        }
        return (
          <div className="enter-input-tag" id="tag-button" key={idx.toString()}>
            + {tags.length - idx}...
          </div>
        );
      })}
    </div>
  );
};

export default OrderedTags;
